

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { RotateCcw, Filter, Search } from "feather-icons-react";
import Select from "react-select";
import { Spin } from "antd";
// import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Swal from "sweetalert2";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";

const LastThreePaySlips = () => {
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const [tokenData, setTokenData] = useState(null);
    const [superIdData, setSuperIdData] = useState(null);

    const [branchesList, setBranchesList] = useState([]);
    const [deptList, setDeptList] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);

    const [tableBranchId, setTableBranchId] = useState(0);
    const [tableDeptId, setTableDeptId] = useState(0);
    const [selectedEmpId, setSelectedEmpId] = useState(0);

    const [last3Payslips, setLast3Payslips] = useState([]);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleReload = () => {
        window.location.reload();
    };

    // For now — PDF generation is removed because it was tied to single payslip
    // You can re-implement it later to generate PDF for all 3 or the latest one
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );

    const BranchesOptions = [
        { label: "All Branches", value: 0 },
        ...branchesList.map((branch) => ({
            label: branch.Name,
            value: branch.branchid,
        })),
    ];

    const DeptOptions = [
        { label: "All Departments", value: 0 },
        ...deptList.map((dept) => ({
            label: dept.Name,
            value: dept.DepartmentId,
        })),
    ];

    const employeeOptions = [
        { label: "Select Employee", value: 0 },
        ...filteredEmployees.map((emp) => ({
            label: emp.UserWithBadge,
            value: emp.RegId,
        })),
    ];

    // ────────────────────────────────────────────────
    //  Fetch token & superId
    // ────────────────────────────────────────────────
    useEffect(() => {
        const token = sessionStorage.getItem("authToken");
        const superId = sessionStorage.getItem("PayrollSuperId");

        if (token && superId) {
            setTokenData(token);
            setSuperIdData(superId);
        } else {
            console.warn("User data not found in sessionStorage");
            navigate("/signin");
        }
    }, [navigate]);

    // Branches
    useEffect(() => {
        if (!tokenData || !superIdData) return;

        const fetchBranches = async () => {
            try {
                const res = await fetch(
                    `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
                        },
                    }
                );
                const data = await res.json();
                if (data.status) setBranchesList(data.ResultData || []);
            } catch (err) {
                console.error("Branches fetch error:", err);
            }
        };
        fetchBranches();
    }, [tokenData, superIdData]);

    // Departments
    useEffect(() => {
        if (!tokenData || !superIdData) return;

        const fetchDepts = async () => {
            try {
                const res = await fetch(
                    `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
                        },
                    }
                );
                const data = await res.json();
                if (data.status) setDeptList(data.ResultData || []);
            } catch (err) {
                console.error("Departments fetch error:", err);
            }
        };
        fetchDepts();
    }, [tokenData, superIdData]);

    // Employees (filtered by branch & dept)
    useEffect(() => {
        if (!superIdData) return;

        const fetchEmployees = async () => {
            try {
                const res = await fetch(
                    `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${tableBranchId}&DeptId=${tableDeptId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
                        },
                    }
                );
                const data = await res.json();
                setFilteredEmployees(data.status ? data.ResultData || [] : []);
            } catch (err) {
                console.error("Employees fetch error:", err);
                setFilteredEmployees([]);
            }
        };

        fetchEmployees();
    }, [superIdData, tableBranchId, tableDeptId]);

    // Fetch last 3 payslips
    const fetchLastThree = async () => {
        if (!selectedEmpId || selectedEmpId === 0) {
            Swal.fire({
                icon: "warning",
                title: "Missing Selection",
                text: "Please select an employee",
                confirmButtonColor: "#3085d6",
            });
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(
                `${Payroll_API_BASE_URL}payroll/payslips/getlast3payslips?SuperId=${superIdData}&RegId=${selectedEmpId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
                    },
                }
            );

            const data = await res.json();

            if (data.status && data.ResultData?.length > 0) {
                setLast3Payslips(data.ResultData);
            } else {
                setLast3Payslips([]);
                Swal.fire({
                    icon: "info",
                    title: "No Payslips Found",
                    text: "No recent payslips available for this employee.",
                });
            }
        } catch (err) {
            console.error("Last 3 payslips error:", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to load payslips. Please try again.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <style>{`
        .payslip-container {
          max-width: 620px;
          margin: 0 auto 2.5rem;
          padding: 16px;
          border: 1px solid #444;
          border-radius: 6px;
          background: #fff;
          font-family: Arial, sans-serif;
          font-size: 13px;
          line-height: 1.4;
        }
        .payslips-wrapper {
          max-height: calc(100vh - 220px);
          overflow-y: auto;
          padding-right: 8px;
        }
        .table-sm td, .table-sm th {
          padding: 0.45rem;
          font-size: 0.875rem;
        }
      `}</style>

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header m-2">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/rollcall/dashboard">
                                                <i className="fas fa-home fa-lg" />
                                            </Link>
                                        </li>
                                        <h4 className="breadcrumb-item " aria-current="page">
                                            Last 3 Months Pay Slips
                                        </h4>
                                    </ol>
                                </nav>
                                <h6>Manage your Pay Slip here</h6>
                            </div>
                        </div>

                        <ul className="table-top-head">
                            {/* PDF button removed for now — can be re-added later */}
                            <li onClick={handleReload}>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                                    <Link>
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>

                    <div className="row align-items-stretch">
                        {/* Left panel - Filters */}
                        <div className="col-md-4">
                            <div className="card p-4">
                                <div className="row g-3">
                                    {showAdvancedSearch && (
                                        <>
                                            <div className="col-12">
                                                <label className="form-label">Branch</label>
                                                <Select
                                                    isClearable
                                                    placeholder="Select Branch"
                                                    classNamePrefix="react-select"
                                                    options={BranchesOptions}
                                                    value={BranchesOptions.find((opt) => opt.value === tableBranchId)}
                                                    onChange={(sel) => {
                                                        setTableBranchId(sel?.value || 0);
                                                        setSelectedEmpId(0); // reset employee
                                                    }}
                                                />
                                            </div>

                                            <div className="col-12">
                                                <label className="form-label">Department</label>
                                                <Select
                                                    isClearable
                                                    placeholder="Select Department"
                                                    classNamePrefix="react-select"
                                                    options={DeptOptions}
                                                    value={DeptOptions.find((opt) => opt.value === tableDeptId)}
                                                    onChange={(sel) => {
                                                        setTableDeptId(sel?.value || 0);
                                                        setSelectedEmpId(0); // reset employee
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className="col-12">
                                        <label className="form-label">Employee</label>
                                        <Select
                                            isClearable
                                            placeholder="Select Employee"
                                            classNamePrefix="react-select"
                                            options={employeeOptions}
                                            value={employeeOptions.find((opt) => opt.value === selectedEmpId)}
                                            onChange={(sel) => setSelectedEmpId(sel?.value || 0)}
                                        />
                                    </div>

                                    <div className="col-12 d-flex justify-content-between align-items-center mt-3">
                                        <button
                                            className="btn btn-outline-primary"
                                            onClick={() => {
                                                setShowAdvancedSearch((prev) => !prev);
                                                if (!showAdvancedSearch) {
                                                    setTableBranchId(0);
                                                    setTableDeptId(0);
                                                }
                                                setSelectedEmpId(0);
                                                setLast3Payslips([]);
                                            }}
                                            style={{ width: 42, height: 42 }}
                                        >
                                            {showAdvancedSearch ? <Search size={20} /> : <Filter size={20} />}
                                        </button>

                                        <button className="btn btn-primary" onClick={fetchLastThree}>
                                            <FontAwesomeIcon icon={faPrint} /> Print
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right panel - Result */}
                        <div className="card table-list-card col-md-8 pb-5 pt-1 px-4 extra-pb">
                            {loading && (
                                <div
                                    className="position-absolute top-50 start-50 translate-middle"
                                    style={{ zIndex: 10 }}
                                >
                                    <Spin size="large" tip="Loading Payslip..." />
                                </div>
                            )}

                            <div className="card-body payslip-card-body">
                                {last3Payslips.length === 0 && !loading && (
                                    <div className="d-flex justify-content-center mt-5 text-muted">
                                        <p>Select an employee and click to view payslips</p>
                                    </div>
                                )}

                                {last3Payslips.length > 0 && (
                                    <div
                                        className="payslips-wrapper"
                                        style={{
                                            maxHeight: "calc(100vh - 40px)",
                                            overflowY: "auto",
                                            paddingRight: "8px",
                                        }}
                                    >
                                        {last3Payslips.map((slip, index) => {
                                            const earnings = slip.Earnings || [];
                                            const deductions = slip.Deductions || [];
                                            const maxR = Math.max(earnings.length, deductions.length);
                                            const rows = Array.from({ length: maxR }, (_, i) => ({
                                                earning: earnings[i] || null,
                                                deduction: deductions[i] || null,
                                            }));

                                            return (
                                                <div
                                                    key={index}
                                                    className="payslip-container mb-5 shadow-sm"
                                                    style={{
                                                        border: "1px solid #444",
                                                        borderRadius: "6px",
                                                        background: "#fff",
                                                        padding: "16px",
                                                    }}
                                                >
                                                    <div className="text-center mb-2">
                                                        <small className="text-muted">Payslip #{index + 1}</small>
                                                    </div>

                                                    <div
                                                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderBottom: "1px solid #333",
                          paddingBottom: "6px",
                        }}
                        className="mb-1"
                                                    >
                                                        <img src="/assets/img/logo.png" alt="Logo" style={{ height: 30 }} />
                                                        <div style={{ flex: 1, textAlign: "center" }}>
                                                            <h1>{slip.OrgName}</h1>
                                                        </div>
                                                    </div>

                                                    <table className="table table-bordered table-sm mb-3">
                                                        <tbody>
                                                            <tr>
                                                                <td><strong>Name</strong></td><td>{slip.UserName}</td>
                                                                <td>  <strong>Employee ID</strong></td><td>{slip.BadgeId}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Department</strong></td><td>{slip.Department}</td>
                                                                <td><strong>Designation</strong></td><td>{slip.Designation}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>No Of Days</strong></td><td>{slip.WorkingDays}</td>
                                                                <td> <strong>Pan No</strong></td><td>{slip.PAN || "N/A"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Pay Date</strong></td><td>{formatDate(slip.PayPeriodName)}</td>
                                                                <td> <strong>Date of Joining</strong></td><td>{formatDate(slip.DateOfJoining)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table className="table table-bordered table-sm" style={{ fontSize: "12px" }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ background: "#fae676ff", color: "#000" }}>Earnings</th>
                                                                <th className="text-end" style={{ background: "#fae676ff", color: "#000" }}>₹ Amount</th>
                                                                <th style={{ background: "#d90f0fff", color: "#fff" }}>Deductions</th>
                                                                <th className="text-end" style={{ background: "#d90f0fff", color: "#fff" }}>₹ Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rows.map((r, i) => (
                                                                <tr key={i}>
                                                                    <td>{r.earning?.SalaryHead || ""}</td>
                                                                    <td className="text-end">{r.earning ? r.earning.Amount.toFixed(2) : ""}</td>
                                                                    <td>{r.deduction?.SalaryHead || ""}</td>
                                                                    <td className="text-end">{r.deduction ? r.deduction.Amount.toFixed(2) : ""}</td>
                                                                </tr>
                                                            ))}
                                                            <tr className="fw-bold bg-light">
                                                                <td>Total</td>
                                                                <td className="text-end">{slip.EarningsTotal?.toFixed(2)}</td>
                                                                <td>Total</td>
                                                                <td className="text-end">{slip.DeductionsTotal?.toFixed(2)}</td>
                                                            </tr>
                                                            <tr className="fw-bold">
                                                                <td colSpan={3} className="text-end bg-success text-white">Net Salary</td>
                                                                <td className="text-end bg-success text-white">{slip.NetSalary?.toFixed(2)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div style={{ fontSize: "10px", textAlign: "center", marginTop: "10px", color: "#555" }}>
                                                        System generated payslip | Generated by <strong>Perennial Code</strong>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <CommonFooter />
            </div>
        </>
    );
};

export default LastThreePaySlips;






// import React, { useEffect, useState, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom/dist";
// // import Table from "../../../../../core/pagination/datatable";
// import CommonFooter from "../../../../core/common/footer/commonFooter";
// // import { Select } from "antd";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { RotateCcw } from "feather-icons-react/build/IconComponents";
// import { faPrint } from "@fortawesome/free-solid-svg-icons";
// import Select from "react-select";
// import { Spin } from "antd";
// import { Filter, Search } from "feather-icons-react/build/IconComponents";
// import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
// import Swal from "sweetalert2";
// import { Payroll_API_BASE_URL } from "../PConfig/PConfig";


// const PaySlip = () => {
//   const [showPayslip, setShowPayslip] = useState(false);
//   const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
//   const [tokenData, setTokenData] = useState(null);
//   const [superIdData, setSuperIdData] = useState(null);
//   const [branchesList, setBranchesList] = useState([]);
//   const [DeptList, setDeptList] = useState([]);
//   const [tableFilteredEmployees, setTableFilteredEmployees] = useState([]);
//   const [PayPeriodlist, setPayPeriodlist] = useState([]);

//   const [tableBranchId, setTableBranchId] = useState(0);
//   const [tableDeptId, setTableDeptId] = useState(0);
//   const [tableEmpId, setTableEmpId] = useState(0);


//   const [selectedPayPeriod, setSelectedPayPeriod] = useState(null);
//   const [payslipData, setPayslipData] = useState(null);
//   console.log(payslipData);
//   const [loadingPayslip, setLoadingPayslip] = useState(false);
//   const [last3PayslipData, setLast3PayslipData] = useState([]);
//   const [activeTab, setActiveTab] = useState("payslip");
//   const navigate = useNavigate();

//   const payslipRef = useRef(null);

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleReload = () => {
//     window.location.reload();
//   };




//   const generatePDF = () => {
//     if (!payslipData) {
//       Swal.fire({
//         icon: "warning",
//         title: "No Payslip",
//         text: "Please generate the payslip before downloading the PDF",
//         confirmButtonColor: "#3085d6",
//       });
//       return;
//     }
//     const doc = new jsPDF("p", "mm", "a4");
//     const pageWidth = doc.internal.pageSize.getWidth();

//     const borderX = 10;
//     const borderY = 10;
//     const borderWidth = 190;

//     const logo = "/assets/img/logo.png";
//     doc.addImage(logo, "PNG", 25, 20, 30, 12);

//     doc.setFontSize(16);
//     doc.setFont("helvetica", "bold");
//     doc.text(payslipData.OrgName, pageWidth / 2, 26, { align: "center" });

//     doc.setLineWidth(0.5);
//     doc.line(20, 32, pageWidth - 20, 32);

//     doc.autoTable({
//       startY: 35,
//       theme: "grid",
//       styles: { fontSize: 9, cellPadding: 3 },
//       columnStyles: {
//         0: { fontStyle: "bold", cellWidth: 35 },
//         1: { cellWidth: 55 },
//         2: { fontStyle: "bold", cellWidth: 35 },
//         3: { cellWidth: 55 },
//       },
//       body: [
//         ["Name", payslipData.UserName, "Employee ID", payslipData.BadgeId],
//         ["Department", payslipData.Department, "Designation", payslipData.Designation],
//         ["No of Days", payslipData.WorkingDays, "PAN No", payslipData.PAN || "N/A"],
//         ["Pay Date", formatDate(payslipData.PayPeriodName), "Date of Joining", formatDate(payslipData.DateOfJoining)],
//       ],
//     });

//     const earnings = payslipData.Earnings || [];
//     const deductions = payslipData.Deductions || [];
//     const rows = Math.max(earnings.length, deductions.length);

//     const body = [];
//     for (let i = 0; i < rows; i++) {
//       body.push([
//         earnings[i]?.SalaryHead || "",
//         earnings[i] ? earnings[i].Amount.toFixed(2) : "",
//         deductions[i]?.SalaryHead || "",
//         deductions[i] ? deductions[i].Amount.toFixed(2) : "",
//       ]);
//     }

//     body.push([
//       "Total",
//       payslipData.EarningsTotal.toFixed(2),
//       "Total",
//       payslipData.DeductionsTotal.toFixed(2),
//     ]);

//     body.push([
//       "Net Salary",
//       "",
//       "",
//       payslipData.NetSalary.toFixed(2),
//     ]);

//     doc.autoTable({
//       startY: doc.lastAutoTable.finalY + 5,
//       theme: "grid",
//       styles: { fontSize: 9, cellPadding: 3 },
//       headStyles: { textColor: [255, 255, 255] },
//       head: [[
//         { content: "Earnings", styles: { fillColor: [250, 230, 118], textColor: [0, 0, 0] } },
//         { content: "Amount", styles: { fillColor: [250, 230, 118], textColor: [0, 0, 0], halign: "right" } },
//         { content: "Deductions", styles: { fillColor: [217, 15, 15] } },
//         { content: "Amount", styles: { fillColor: [217, 15, 15], halign: "right" } },
//       ]],
//       columnStyles: {
//         0: { cellWidth: 60 },
//         1: { cellWidth: 30, halign: "right" },
//         2: { cellWidth: 60 },
//         3: { cellWidth: 30, halign: "right" },
//       },
//       body,
//       didParseCell: function (data) {
//         if (data.row.index === body.length - 2) {
//           data.cell.styles.fontStyle = "bold";
//           data.cell.styles.fillColor = [240, 240, 240];
//         }
//         if (data.row.index === body.length - 1) {
//           data.cell.styles.fontStyle = "bold";
//           data.cell.styles.fillColor = [0, 128, 0];
//           data.cell.styles.textColor = [255, 255, 255];
//         }
//       },
//     });

//     const finalY = doc.lastAutoTable.finalY + 8;

//     doc.setFontSize(8);
//     doc.text(
//       "System generated payslip | Generated by Perennial Code",
//       pageWidth / 2,
//       finalY,
//       { align: "center" }
//     );

//     doc.setDrawColor(0);
//     doc.setLineWidth(0.8);
//     doc.roundedRect(
//       borderX,
//       borderY,
//       borderWidth,
//       finalY - borderY + 6, // 👈 dynamic height
//       6,
//       6
//     );

//     doc.save(`Payslip_${payslipData.BadgeId}.pdf`);
//   };


//   const renderTooltip = (props) => (
//     <Tooltip id="pdf-tooltip" {...props}>
//       PDF
//     </Tooltip>
//   );

//   const renderRefreshTooltip = (props) => (
//     <Tooltip id="refresh-tooltip" {...props}>
//       Refresh
//     </Tooltip>
//   );
//   const BranchesOptions = [
//     { label: "All Branches", value: 0 },
//     ...branchesList.map((branch) => ({
//       label: branch.Name,
//       value: branch.branchid,
//     })),
//   ];
//   const DeptOptions = [
//     { label: "All Dept", value: 0 },
//     ...DeptList.map((Dept) => ({
//       label: Dept.Name,
//       value: Dept.DepartmentId,
//     })),
//   ];
//   const PayperiodOptions = [
//     { label: "All PayPeriods", value: 0 },
//     ...(PayPeriodlist?.map((period) => ({
//       label: period.Name,
//       value: period.Id,
//     })) || []),
//   ];
//   const employeeOptions = [
//     { label: "Select Employee", value: 0 },
//     ...tableFilteredEmployees.map(emp => ({
//       label: emp.UserWithBadge,
//       value: emp.RegId,
//     }))
//   ];



//   useEffect(() => {
//     const token = sessionStorage.getItem("authToken");
//     // const superId = sessionStorage.getItem("superId");
//     const superId = sessionStorage.getItem("PayrollSuperId");

//     if (token && superId) {
//       setTokenData(token);
//       setSuperIdData(superId);
//     } else {
//       console.warn("User data not found in sessionStorage");
//       navigate("/signin");
//     }
//   }, [navigate]);

//   useEffect(() => {
//     if (tokenData && superIdData) {
//       const fetchBranchsList = async () => {
//         try {
//           const response = await fetch(
//             `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
//               },
//             }
//           );

//           if (!response.ok) {
//             throw new Error("Failed to fetch Branches");
//           }

//           const data = await response.json();

//           if (data.status) {
//             setBranchesList(data.ResultData);
//           } else {
//             console.error("Invalid Branches response structure:", data);
//           }
//         } catch (error) {
//           console.error("Error fetching BranchesList:", error.message);
//         }
//       };
//       fetchBranchsList();
//     }
//   }, [superIdData, tokenData]);

//   useEffect(() => {
//     if (tokenData && superIdData) {
//       const fetchDeptList = async () => {
//         try {
//           const response = await fetch(
//             `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
//               },
//             }
//           );

//           if (!response.ok) {
//             throw new Error("Failed to fetch Dept");
//           }

//           const data = await response.json();

//           if (data.status) {
//             setDeptList(data.ResultData);
//           } else {
//             console.error("Invalid Dept response structure:", data);
//           }
//         } catch (error) {
//           console.error("Error fetching DeptList:", error.message);
//         }
//       };
//       fetchDeptList();
//     }
//   }, [superIdData, tokenData]);

//   useEffect(() => {
//     if (tokenData && superIdData) {
//       const fetchPayperiodList = async () => {
//         try {
//           const response = await fetch(
//             `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
//               },
//             }
//           );

//           if (!response.ok) {
//             throw new Error("Failed to fetch PayPeriods");
//           }

//           const data = await response.json();

//           if (data.status) {
//             setPayPeriodlist(data.ResultData);
//           } else {
//             console.error("Invalid PayPeriod response structure:", data);
//           }
//         } catch (error) {
//           console.error("Error fetching PayPeriodList:", error.message);
//         }
//       };
//       fetchPayperiodList();
//     }
//   }, [superIdData, tokenData]);

//   useEffect(() => {
//     if (!superIdData) return;

//     const fetchTableEmployees = async () => {
//       try {

//         const branchId = tableBranchId || 0;
//         const deptId = tableDeptId || 0;

//         const response = await fetch(
//           `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${branchId}&DeptId=${deptId}`,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
//             },
//           }
//         );

//         const data = await response.json();
//         setTableFilteredEmployees(data.status ? data.ResultData : []);

//       } catch (error) {
//         console.error("Employee fetch error:", error);
//         setTableFilteredEmployees([]);
//       }
//     };

//     fetchTableEmployees();

//   }, [superIdData, tableBranchId, tableDeptId]);

//   const fetchPayslip = async () => {

//     if (!selectedPayPeriod || !tableEmpId) {
//       Swal.fire({
//         icon: "warning",
//         title: "Missing Selection",
//         text: "Please select both Employee and Pay Period",
//         confirmButtonColor: "#3085d6",
//       });
//       return;
//     }

//     try {
//       setLoadingPayslip(true);

//       const response = await fetch(
//         `${Payroll_API_BASE_URL}payroll/payslips/getpayslips?SuperId=${superIdData}&PayperiodId=${selectedPayPeriod.value}&RegId=${tableEmpId}&BranchId=${tableBranchId}&DeptId=${tableDeptId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.status && data.ResultData.length > 0) {
//         setPayslipData(data.ResultData[0]);
//         setShowPayslip(true);
//       } else {
//         Swal.fire({
//           icon: "info",
//           title: "No Payslip",
//           text: "No payslip found for the selected employee and pay period",
//           confirmButtonColor: "#3085d6",
//         });
//         setPayslipData(null);
//       }
//     } catch (error) {
//       console.error("Payslip fetch error:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to fetch payslip. Please try again later.",
//         confirmButtonColor: "#d33",
//       });

//     } finally {
//       setLoadingPayslip(false);
//     }
//   };
//   const fetchLast3Payslips = async () => {

//     if (!tableEmpId) {
//       Swal.fire({
//         icon: "warning",
//         title: "Missing Selection",
//         text: "Please select Employee",
//         confirmButtonColor: "#3085d6",
//       });
//       return;
//     }

//     try {
//       setLoadingPayslip(true);

//       const response = await fetch(
//         `${Payroll_API_BASE_URL}payroll/payslips/getlast3payslips?SuperId=${superIdData}&RegId=${tableEmpId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.status && data.ResultData.length > 0) {
//         setLast3PayslipData(data.ResultData);
//         setShowPayslip(true);
//       } else {
//         Swal.fire({
//           icon: "info",
//           title: "No Payslips",
//           text: "No last 3 months payslips found",
//         });

//         setLast3PayslipData([]);
//       }

//     } catch (error) {
//       console.error("Last 3 Payslip fetch error:", error);

//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to fetch last 3 months payslips",
//       });

//     } finally {
//       setLoadingPayslip(false);
//     }
//   };
//   useEffect(() => {
//     setShowPayslip(false);
//     setPayslipData(null);
//     setLast3PayslipData([]);
//   }, [activeTab]);

//   const earnings = payslipData?.Earnings || [];
//   const deductions = payslipData?.Deductions || [];

//   const maxRows = Math.max(earnings.length, deductions.length);

//   const combinedRows = Array.from({ length: maxRows }, (_, i) => ({
//     earning: earnings[i] || null,
//     deduction: deductions[i] || null,
//   }));

//   return (
//     <>
//       <style>
//         {`
//        .sno-col {
//   width: 35px;
//   text-align: center;
//   font-size: 12px;
// }

// .amount-col {
//   width: 90px;
//   font-size: 12px;
// }

// .table td,
// .table th {
//   padding: 6px;
//   font-size: 13px;
//   word-wrap: break-word;
// }
//   .attendance-head th {
//   background-color: #bcedf8ff !important;
//   color: #fff;
// }
//   .payslip-card-body {
          
//   margin: 0;     
//   padding-top:2;        
       
  
// }
//   .payslip-container {
//   max-width: 600px;
//   margin: 0 auto;         /* center horizontally */
//   padding: 12px;
//   border: 1px solid #333;
//   font-family: Arial, sans-serif;
//   font-size: 13px;
//   line-height: 1.2;
//   background-color: #fff;
// }

//       `}
//       </style>

//       <div>
//         <div className="page-wrapper">
//           <div className="content">
//             <div className="page-header m-2">
//               <div className="add-item d-flex">
//                 <div className="page-title">
//                   <nav aria-label="breadcrumb">
//                     <ol className="breadcrumb">
//                       <li className="breadcrumb-item">
//                         <Link to="/rollcall/dashboard">
//                           <i className="fas fa-home fa-lg" />
//                         </Link>
//                       </li>
//                       <h4 className="breadcrumb-item " aria-current="page">
//                         Pay Slips
//                       </h4>
//                     </ol>
//                   </nav>
//                   <h6>Manage your Pay Slip here</h6>
//                 </div>
//               </div>
//               <ul className="table-top-head">
//                 <li>
//                   <OverlayTrigger placement="top" overlay={renderTooltip}>
//                     <Link onClick={generatePDF}>
//                       <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="PDF" />
//                     </Link>
//                   </OverlayTrigger>
//                 </li>
//                 <li onClick={handleReload}>
//                   <OverlayTrigger
//                     placement="top"
//                     overlay={renderRefreshTooltip}
//                   >
//                     <Link>
//                       <RotateCcw />
//                     </Link>
//                   </OverlayTrigger>
//                 </li>
//               </ul>
//             </div>
//             <div className="row align-items-stretch">

//               <div className="col-md-4">
//                 <div className="card p-4">

//                   {/* Tabs Header */}
//                   <ul className="nav nav-tabs nav-tabs-bottom nav-justified mb-3">
//                     <li className="nav-item">
//                       <Link
//                         className={`nav-link ${activeTab === "payslip" ? "active" : ""}`}
//                         to="#payslip-tab1"
//                         data-bs-toggle="tab"
//                         onClick={() => setActiveTab("payslip")}
//                       >
//                         Payslip
//                       </Link>
//                     </li>

//                     <li className="nav-item">
//                       <Link
//                         className={`nav-link ${activeTab === "last3" ? "active" : ""}`}
//                         to="#payslip-tab2"
//                         data-bs-toggle="tab"
//                         onClick={() => setActiveTab("last3")}
//                       >
//                         Last 3 Months
//                       </Link>
//                     </li>
//                   </ul>

//                   <div className="tab-content">

//                     {/* ================= Payslip TAB ================= */}
//                     <div className="tab-pane fade show active" id="payslip-tab1">
//                       <div className="row g-3">

//                         {showAdvancedSearch && (
//                           <>
//                             <div className="col-12">
//                               <label className="form-label">Branch</label>
//                               <Select
//                                 isClearable
//                                 isSearchable
//                                 placeholder="Select Branch"
//                                 classNamePrefix="react-select"
//                                 options={BranchesOptions}
//                                 value={BranchesOptions.find(opt => opt.value === tableBranchId)}
//                                 onChange={(selected) => setTableBranchId(selected?.value || 0)}
//                               />
//                             </div>

//                             <div className="col-12">
//                               <label className="form-label">Department</label>
//                               <Select
//                                 isClearable
//                                 isSearchable
//                                 classNamePrefix="react-select"
//                                 placeholder="Select Dept"
//                                 options={DeptOptions}
//                                 value={DeptOptions.find(opt => opt.value === tableDeptId)}
//                                 onChange={(selected) => setTableDeptId(selected?.value || 0)}
//                               />
//                             </div>
//                           </>
//                         )}

//                         {/* Employee */}
//                         <div className="col-12">
//                           <label className="form-label">Employee</label>
//                           <Select
//                             isClearable
//                             isSearchable
//                             classNamePrefix="react-select"
//                             placeholder="Select Employee"
//                             options={employeeOptions}
//                             value={employeeOptions.find(opt => opt.value === tableEmpId)}
//                             onChange={(selected) => setTableEmpId(selected?.value || 0)}
//                           />
//                         </div>

//                         {/* Pay Period */}
//                         <div className="col-12">
//                           <label className="form-label">Pay Period</label>
//                           <Select
//                             isClearable
//                             isSearchable
//                             classNamePrefix="react-select"
//                             placeholder="Select PayPeriod"
//                             options={PayperiodOptions}
//                             value={selectedPayPeriod}
//                             onChange={(selected) => setSelectedPayPeriod(selected)}
//                           />
//                         </div>

//                         {/* Actions */}
//                         <div className="col-12 d-flex justify-content-between align-items-center mt-2">
//                           <button
//                             className="btn btn-outline-primary"
//                             onClick={() => {
//                               setShowAdvancedSearch(prev => !prev);
//                               setTableBranchId(0);
//                               setTableDeptId(0);
//                               setTableEmpId(0);
//                               setSelectedPayPeriod(0);
//                             }}
//                             style={{ width: 38, height: 38 }}
//                           >
//                             {showAdvancedSearch ? <Search size={20} /> : <Filter size={20} />}
//                           </button>

//                           <button className="btn btn-primary" onClick={fetchPayslip}>
//                             <FontAwesomeIcon icon={faPrint} /> Print
//                           </button>
//                         </div>

//                       </div>
//                     </div>


//                     {/* ================= Last 3 Months TAB ================= */}
//                     <div className="tab-pane fade" id="payslip-tab2">
//                       <div className="row g-3">

//                         {showAdvancedSearch && (
//                           <>
//                             <div className="col-12">
//                               <label className="form-label">Branch</label>
//                               <Select
//                                 isClearable
//                                 isSearchable
//                                 classNamePrefix="react-select"
//                                 placeholder="Select Branch"
//                                 options={BranchesOptions}
//                                 value={BranchesOptions.find(opt => opt.value === tableBranchId)}
//                                 onChange={(selected) => setTableBranchId(selected?.value || 0)}
//                               />
//                             </div>

//                             <div className="col-12">
//                               <label className="form-label">Department</label>
//                               <Select
//                                 isClearable
//                                 isSearchable
//                                 classNamePrefix="react-select"
//                                 placeholder="Select Dept"
//                                 options={DeptOptions}
//                                 value={DeptOptions.find(opt => opt.value === tableDeptId)}
//                                 onChange={(selected) => setTableDeptId(selected?.value || 0)}
//                               />
//                             </div>
//                           </>
//                         )}

//                         {/* Employee */}
//                         <div className="col-12">
//                           <label className="form-label">Employee</label>
//                           <Select
//                             isClearable
//                             isSearchable
//                             classNamePrefix="react-select"
//                             placeholder="Select Employee"
//                             options={employeeOptions}
//                             value={employeeOptions.find(opt => opt.value === tableEmpId)}
//                             onChange={(selected) => setTableEmpId(selected?.value || 0)}
//                           />
//                         </div>

//                         {/* Actions */}
//                         <div className="col-12 d-flex justify-content-between align-items-center mt-2">
//                           <button
//                             className="btn btn-outline-primary"
//                             onClick={() => setShowAdvancedSearch(prev => !prev)}
//                             style={{ width: 38, height: 38 }}
//                           >
//                             {showAdvancedSearch ? <Search size={20} /> : <Filter size={20} />}
//                           </button>

//                           <button className="btn btn-primary" onClick={fetchLast3Payslips}>
//                             <FontAwesomeIcon icon={faPrint} /> Print
//                           </button>
//                         </div>

//                       </div>
//                     </div>

//                   </div>
//                 </div>
//               </div>

//               <div className="card table-list-card col-md-8 pb-5 pt-1 px-4 extra-pb">
//                 {loadingPayslip && (
//                   <div
//                     className="position-absolute top-50 start-50 translate-middle"
//                     style={{ zIndex: 10 }}
//                   >
//                     <Spin size="large" tip="Loading Payslip..." />
//                   </div>
//                 )}

//                 <div className="card-body payslip-card-body">
//                   {!showPayslip && (
//                     <div className="d-flex justify-content-center mt-5 text-muted">
//                       <p>Select filters and click Print to view payslip(s)</p>
//                     </div>
//                   )}

//                   {showPayslip && !loadingPayslip && (
//                     <>
//                       {last3PayslipData.length === 0 && payslipData && (
//                         <div className="payslip-container mb-4" ref={payslipRef} id="payslip-print-compact">
//                           {/* Your existing single payslip content */}
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               borderBottom: "1px solid #333",
//                               paddingBottom: "6px",
//                             }}
//                             className="mb-1"
//                           >
//                             <img src="/assets/img/logo.png" alt="Logo" style={{ height: 30 }} />
//                             <div style={{ flex: 1, textAlign: "center" }}>
//                               <h1>{payslipData?.OrgName}</h1>
//                             </div>
//                           </div>

//                           <table className="table table-bordered mb-1">
//                             <tbody>
//                               <tr>
//                                 <td><strong>Name</strong></td>
//                                 <td>{payslipData?.UserName}</td>
//                                 <td><strong>Employee ID</strong></td>
//                                 <td>{payslipData?.BadgeId}</td>
//                               </tr>
//                               <tr>
//                                 <td><strong>Department</strong></td>
//                                 <td>{payslipData?.Department}</td>
//                                 <td><strong>Designation</strong></td>
//                                 <td>{payslipData?.Designation}</td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   <strong>No Of Days</strong>
//                                 </td>
//                                 <td>{payslipData?.WorkingDays}</td>
//                                 <td>
//                                   <strong>Pan No</strong>
//                                 </td>
//                                 <td>{payslipData?.PAN || "N/A"}</td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   <strong>Pay Date</strong>
//                                 </td>
//                                 <td>{formatDate(payslipData?.PayPeriodName)}</td>
//                                 <td>
//                                   <strong>Date of Joining</strong>
//                                 </td>
//                                 <td>{formatDate(payslipData?.DateOfJoining)}</td>
//                               </tr>
//                             </tbody>
//                           </table>

//                           <table className="table table-bordered mt-2" style={{ width: "100%", tableLayout: "fixed", fontSize: "12px" }}>
//                             <thead>
//                               <tr>
//                                 <th style={{ background: "#fae676ff", color: "#000" }}>Earnings</th>
//                                 <th className="text-end" style={{ background: "#fae676ff", color: "#000" }}>₹ Amount</th>
//                                 <th style={{ background: "#d90f0fff", color: "#fff" }}>Deductions</th>
//                                 <th className="text-end" style={{ background: "#d90f0fff", color: "#fff" }}>₹ Amount</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {combinedRows.map((row, i) => (
//                                 <tr key={i}>
//                                   <td>{row.earning?.SalaryHead || ""}</td>
//                                   <td className="text-end">{row.earning ? row.earning.Amount.toFixed(2) : ""}</td>
//                                   <td>{row.deduction?.SalaryHead || ""}</td>
//                                   <td className="text-end">{row.deduction ? row.deduction.Amount.toFixed(2) : ""}</td>
//                                 </tr>
//                               ))}
//                               <tr className="fw-bold bg-light">
//                                 <td>Total</td>
//                                 <td className="text-end">{payslipData?.EarningsTotal.toFixed(2)}</td>
//                                 <td>Total</td>
//                                 <td className="text-end">{payslipData?.DeductionsTotal.toFixed(2)}</td>
//                               </tr>
//                               <tr className="fw-bold">
//                                 <td colSpan={3} className="text-end bg-success text-white">Net Salary</td>
//                                 <td className="text-end bg-success text-white">{payslipData?.NetSalary.toFixed(2)}</td>
//                               </tr>
//                             </tbody>
//                           </table>

//                           <div style={{ fontSize: "10px", textAlign: "center", marginTop: "8px" }}>
//                             System generated payslip | Generated by <strong>Perennial Code</strong>
//                           </div>
//                         </div>
//                       )}

//                       {last3PayslipData.length > 0 && (
//                         <>
//                           <div
//                             className="payslips-wrapper"
//                             style={{
//                               maxHeight: "calc(100vh - 180px)",
//                               overflowY: "auto",
//                               paddingRight: "8px",
//                             }}
//                           >
//                             {last3PayslipData.map((slip, index) => {
//                               const earnings = slip.Earnings || [];
//                               const deductions = slip.Deductions || [];
//                               const maxR = Math.max(earnings.length, deductions.length);
//                               const rows = Array.from({ length: maxR }, (_, i) => ({
//                                 earning: earnings[i] || null,
//                                 deduction: deductions[i] || null,
//                               }));

//                               return (
//                                 <div
//                                   key={index}
//                                   className="payslip-container mb-5 shadow-sm"
//                                   style={{
//                                     border: "1px solid #444",
//                                     borderRadius: "6px",
//                                     background: "#fff",
//                                     padding: "16px",
//                                   }}
//                                 >
//                                   <div className="text-center mb-2">
//                                     <small className="text-muted">Payslip #{index + 1}</small>
//                                   </div>

//                                   <div
//                                     style={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       borderBottom: "1px solid #333",
//                                       paddingBottom: "8px",
//                                       marginBottom: "12px",
//                                     }}
//                                   >
//                                     <img src="/assets/img/logo.png" alt="Logo" style={{ height: 30 }} />
//                                     <div style={{ flex: 1, textAlign: "center" }}>
//                                       <h2 style={{ margin: 0, fontSize: "1.4rem" }}>{slip.OrgName}</h2>
//                                     </div>
//                                   </div>

//                                   <table className="table table-bordered table-sm mb-3">
//                                     <tbody>
//                                       <tr>
//                                         <td><strong>Name</strong></td><td>{slip.UserName}</td>
//                                         <td>  <strong>Employee ID</strong></td><td>{slip.BadgeId}</td>
//                                       </tr>
//                                       <tr>
//                                         <td><strong>Department</strong></td><td>{slip.Department}</td>
//                                         <td><strong>Designation</strong></td><td>{slip.Designation}</td>
//                                       </tr>
//                                       <tr>
//                                         <td><strong>No Of Days</strong></td><td>{slip.WorkingDays}</td>
//                                         <td> <strong>Pan No</strong></td><td>{slip.PAN || "N/A"}</td>
//                                       </tr>
//                                       <tr>
//                                         <td><strong>Pay Date</strong></td><td>{formatDate(slip.PayPeriodName)}</td>
//                                         <td> <strong>Date of Joining</strong></td><td>{formatDate(slip.DateOfJoining)}</td>
//                                       </tr>
//                                     </tbody>
//                                   </table>

//                                   <table className="table table-bordered table-sm" style={{ fontSize: "12px" }}>
//                                     <thead>
//                                       <tr>
//                                         <th style={{ background: "#fae676ff", color: "#000" }}>Earnings</th>
//                                         <th className="text-end" style={{ background: "#fae676ff", color: "#000" }}>₹ Amount</th>
//                                         <th style={{ background: "#d90f0fff", color: "#fff" }}>Deductions</th>
//                                         <th className="text-end" style={{ background: "#d90f0fff", color: "#fff" }}>₹ Amount</th>
//                                       </tr>
//                                     </thead>
//                                     <tbody>
//                                       {rows.map((r, i) => (
//                                         <tr key={i}>
//                                           <td>{r.earning?.SalaryHead || ""}</td>
//                                           <td className="text-end">{r.earning ? r.earning.Amount.toFixed(2) : ""}</td>
//                                           <td>{r.deduction?.SalaryHead || ""}</td>
//                                           <td className="text-end">{r.deduction ? r.deduction.Amount.toFixed(2) : ""}</td>
//                                         </tr>
//                                       ))}
//                                       <tr className="fw-bold bg-light">
//                                         <td>Total</td>
//                                         <td className="text-end">{slip.EarningsTotal?.toFixed(2)}</td>
//                                         <td>Total</td>
//                                         <td className="text-end">{slip.DeductionsTotal?.toFixed(2)}</td>
//                                       </tr>
//                                       <tr className="fw-bold">
//                                         <td colSpan={3} className="text-end bg-success text-white">Net Salary</td>
//                                         <td className="text-end bg-success text-white">{slip.NetSalary?.toFixed(2)}</td>
//                                       </tr>
//                                     </tbody>
//                                   </table>

//                                   <div style={{ fontSize: "10px", textAlign: "center", marginTop: "10px", color: "#555" }}>
//                                     System generated payslip | Generated by <strong>Perennial Code</strong>
//                                   </div>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </>
//                       )}
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//           <CommonFooter />
//         </div>
//       </div>
//     </>
//   );
// };

// export default PaySlip;


